import React from 'react'

const EditCreatorProfile = () => {
  return (
    <div>EditCreatorProfile</div>
  )
}

export default EditCreatorProfile